
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"75","height":"121","fill":"none"}},[_c('path',{attrs:{"fill":"#478EF8","d":"M73.941 64.016c2.11 3.515.938 8.203-2.578 10.546-1.172.704-2.578.938-3.75.938-2.578 0-5.156-1.172-6.797-3.516l-6.797-10.78V113c0 4.219-3.515 7.5-7.5 7.5-4.218 0-7.5-3.281-7.5-7.5V79.25h-3.75V113c0 4.219-3.281 7.5-7.265 7.5-4.22 0-7.5-3.281-7.5-7.5l.234-51.797-6.797 10.781C11.597 75.5 7.144 76.672 3.63 74.563.113 72.219-1.06 67.53 1.05 64.016l16.64-26.25c2.813-4.453 7.5-7.266 12.656-7.266h14.297c5.157 0 9.844 2.813 12.657 7.266l16.64 26.25zM37.613 23c-6.328 0-11.25-4.922-11.25-11.25C26.363 5.656 31.285.5 37.613.5c6.094 0 11.25 5.156 11.25 11.25 0 6.328-5.156 11.25-11.25 11.25z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      